// React
import React, { useState } from "react";

// External Components
import styled from "@xstyled/styled-components";

// Internal Components
import { grid } from "../../Constants";
import Callout from "../Callout/Callout";
import Input from "./Input";

const Container = styled.div`
  user-select: none;
  display: flex;
  width: 100%;
`;

function getStyle(provided, style) {
  if (!style) {
    return provided.draggableProps.style;
  }
  return {
    ...provided.draggableProps.style,
    ...style,
  };
}

function QuoteItem({
  task,
  taskId,
  isdragging,
  isGroupedOver,
  provided,
  style,
  isClone,
  title,
  overlay,
  active,
  onDragEndSteps,
  addStep,
  aiHelp,
  handleUrgencyChange,
  handleEstimateChange,
  toggleSubTask,
  toggleStep,
  toggleOverlay,
  updateDescription,
  updateStep,
  updateNotes,
  deleteStep,
  deleteSubtask,
  deleteObjective,
  promoteStepToMoment,
  momentValues,
  day,
  viewType,
}) {
  const [calloutActive, setCalloutActive] = useState(false);

  const [displayState, setDisplayState] = useState({
    callout: false,
    deadline: task.deadline ? true : false,
    urgency: task.urgency ? true : false,
  });

  const handleDisplayChange = (e, optionalKey) => {
    let eventData = e.currentTarget.dataset;
    let displayName = e.target.name ? e.target.name : eventData.displayName;

    if (displayName === "remove") {
      if (optionalKey) {
        setDisplayState((prevState) => ({
          ...prevState,
          [optionalKey]: false,
        }));
      } else {
        setDisplayState((prevState) => ({
          ...prevState,
          [displayName]: false,
        }));
      }
    } else {
      setDisplayState((prevState) => ({
        ...prevState,
        [displayName]: !prevState[displayName],
      }));
    }
  };

  return (
    <>
      <Container
        ref={provided.innerRef}
        {...provided.draggableProps}
        style={getStyle(provided, style)}
        data-is-dragging={isdragging}
        data-testid={task.id}
      >
        {/* Dedicated drag handle — separated from interactive elements */}
        <div className="task-drag-grip" {...provided.dragHandleProps}>
          ⠿
        </div>

        <Input
          task={task}
          taskId={taskId}
          title={title}
          display={displayState}
          deleteSubtask={deleteSubtask}
          toggleSubTask={toggleSubTask}
          toggleOverlay={toggleOverlay}
          updateDescription={updateDescription}
          handleCalloutDisplay={handleDisplayChange}
          handleUrgencyChange={handleUrgencyChange}
          handleEstimateChange={handleEstimateChange}
          mode={day ? "daySubtask" : "task"}
          momentValues={momentValues}
          onPromoteToMoment={
            day && promoteStepToMoment
              ? (text, momentKey) => promoteStepToMoment(momentKey, text)
              : undefined
          }
        />
      </Container>

      <Callout
        id={task.id}
        taskId={taskId}
        active={active}
        steps={task.steps}
        overlay={overlay}
        calloutActive={displayState.callout}
        description={task.description}
        notes={task.notes}
        columnId={title}
        onDragEndSteps={onDragEndSteps}
        addStep={addStep}
        aiHelp={aiHelp}
        toggleStep={toggleStep}
        toggleOverlay={toggleOverlay}
        updateDescription={updateDescription}
        updateStep={updateStep}
        updateNotes={updateNotes}
        deleteStep={deleteStep}
        deleteSubtask={deleteSubtask}
        deleteObjective={deleteObjective}
        handleCalloutDisplay={handleDisplayChange}
        promoteStepToMoment={promoteStepToMoment}
        momentValues={momentValues}
        viewType={viewType}
      />
    </>
  );
}

export default React.memo(QuoteItem);
